module.exports = __webpack_public_path__ + "img/97.29fe6e85.png";